export default __webpack_public_path__ + "static/media/photo-08.92493bbf.jpeg";